import { takeEvery, put, select } from "redux-saga/effects";
import { defineMessages } from "react-intl";
import * as RequestNewDueDateActions from "./requestNewDueDateActions";
import { getTechnicianInfo, makeApiCall } from "../helpers";
import taskServices from "../../services/taskServices";
import { ALERT_TYPES, showAlert } from "../alert/alertActions";
import * as TaskActions from "../task/taskActions";

const messages = defineMessages({
    requestDueDateSucceeded: {
        id: "alerts.request-due-due-sagas.request-due-due-succeeded",
        defaultMessage: "Request new due date succeeded",
        description: "Request new due date succeeded alert message",
    },
    requestDueDateFailed: {
        id: "alerts.request-due-due-sagas.request-due-due-failed",
        defaultMessage: "Request new due date failed",
        description: "Request new due date failed alert message",
    },
});

export const watchRequestNewDueDateRequests = function* () {
    yield takeEvery(RequestNewDueDateActions.REQUEST_NEW_DUE_DATE, requestNewDueDate);
};

const requestNewDueDate = function* (action) {
    try {
        const technicianInfo = yield select(getTechnicianInfo);
        const requestNewDueDateResponse = yield makeApiCall(
            taskServices.requestNewDueDate,
            {
                ...action.requestNewDueDate,
            },
            technicianInfo.userName,
        );

        yield put(RequestNewDueDateActions.requestNewDueDateSucceeded(requestNewDueDateResponse));

        if (action.isFromIncomplete) {
            yield put(TaskActions.incompleteTaskResponse(requestNewDueDateResponse));
        }

        yield put(showAlert(Date.now(), messages.requestDueDateSucceeded, ALERT_TYPES.success));
    } catch (responseError) {
        yield put(showAlert(Date.now(), messages.requestDueDateFailed, ALERT_TYPES.error, { responseError }));
        if (action.isFromIncomplete) {
            yield put(TaskActions.incompleteTaskResponse(null));
        }
    }
};
